import urlcat from "urlcat";

import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

export const SERVICE_USERS_URL = `${TENANT_API_URL}/service-users`;

export const getServiceUserList = async (data: Record<string, unknown>) => {
  try {
    const url = urlcat(`${SERVICE_USERS_URL}/list`, data);
    const response = await axiosInstance.post(url, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getServiceUser = (payload: {
  page: number;
  query: string;
  limit: number | string;
  zone?: any;
  status?: any;
  including?: string;
}) => {
  // logger.trace();
  return axiosInstance.post(
    urlcat(`${SERVICE_USERS_URL}/list`, {
      page: payload.page,
      query: payload.query,
      limit: payload.limit,
      including: payload?.including,
    }),
    {
      zone: payload.zone,
      status: payload.status,
    }
  );
};

export const createServiceUser = (data: any) =>
  axiosInstance.post(`${SERVICE_USERS_URL}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const getServiceUserByIdAsync = async (id: string | undefined) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.get(`${SERVICE_USERS_URL}/${id}`);
};

export const getServiceUserById = async (id: string | undefined) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.get(`${SERVICE_USERS_URL}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateServiceUser = (id: string | undefined, data: any) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.put(`${SERVICE_USERS_URL}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteServiceUser = (id: string | undefined) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.delete(`${SERVICE_USERS_URL}/${id}`);
};

export const getUpcomingServiceUsersBirthdays = async (skip: number) => {
  try {
    const response = await axiosInstance.get(
      `${SERVICE_USERS_URL}/upcoming-birthdays?skip=${skip}`
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getChartData = async () => {
  try {
    const response = await axiosInstance.get(`${SERVICE_USERS_URL}/dashboard`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
